import { KeywordResponse } from '../../models/monitor/KeywordResponse';
import { TagsResponse } from '../../models/tags/TagsResponse';
import { TAG_NAME } from '../../utils/urls';
import { normalizeKeyword } from '../../utils/utils';

// Mirror of llm-common's TagUtils.resolveBrandKey for the frontend's data shape: stats rows key
// tagged brands by their tag key (`chatbeat_tag_name_<id>`) and raw brands by the normalized
// lowercase keyword, while `project.firmName` / `defaultKeyword` may hold a tag key or a raw
// display-cased keyword — comparing the raw form against row keys silently misses (zero stats for
// the own brand). Tag membership is looked up in `tags`, NOT in commonKeywords: the tags-resolved
// commonKeywords list collapses tagged rows to their tag key and loses the member keywords.
export const resolveBrandKey = (key: string, tags: TagsResponse[] | null): string => {
  if (!key || key.startsWith(TAG_NAME)) return key;
  const normalized = normalizeKeyword(key).toLowerCase();
  const tag = tags?.find((t) => t.keywordsData?.some((kd) => kd.normalizedKeyword === normalized));
  return tag ? `${TAG_NAME}${tag.id}` : normalized;
};

export const findTagIdInKeyword = (
  normalizedKeyword: string,
  keywordResponses: KeywordResponse[] | null
) => {
  if (!keywordResponses) {
    return null;
  }

  return findKeyword(normalizedKeyword, keywordResponses)?.tagId || null;
};

export const findKeyword = (normalizedKeyword: string, keywordResponses: KeywordResponse[]) =>
  keywordResponses.find((keywordResponse) => keywordResponse.normalizedKeyword === normalizedKeyword);

// Nazwa marki projektu do nagłówka. Z addonem KEYWORDS_PAGE słownik marek niesie jej etykietę
// (`brand_label`), a `firmNameOrg` tylko oryginalną pisownię keyworda — bez tego nagłówek rozjeżdża
// się z nazwą marki na reszcie ekranów. Bez addonu zostaje `firmNameOrg`, jak było.
export const getBrandDisplayName = (
  firmName: string,
  firmNameOrg: string,
  keywordResponses: KeywordResponse[] | null,
  hasBrandGrouping: boolean
): string =>
  (hasBrandGrouping &&
    Array.isArray(keywordResponses) &&
    findKeyword(firmName, keywordResponses)?.keyword) ||
  firmNameOrg;
